// extracted by mini-css-extract-plugin
module.exports = {"point__text":"styles-module__point__text___XsJLc","point__highlight":"styles-module__point__highlight___kmzh+"};